import gsap from 'gsap';
import { asyncAjaxCall } from './utils';
import { cartClass, loaderClass, scrollInstance, toastInstance } from './main';

class Tickets {
    constructor(){
        this.tickets = document.querySelector('.tickets--component');
        this.isOpen = false;
		this.isAnimating = false;
		this.toastMessage = toastInstance;

        this.init()
    }
    init() {
        //this.open()
        document.querySelectorAll('.cagliari--book-event').forEach(button => {
            button.addEventListener('click', () => {
                this.open()
            })
        })
        this.tickets.querySelector('.tickets--gradient-bg').addEventListener('click', () => {
			this.close()
		})
		this.tickets.querySelector('.close--tickets').addEventListener('click', () => {
			this.close()
		})
    }
	async open() {
		if(this.isOpen || this.isAnimating) return;
		scrollInstance.stop()
		this.isAnimating = true;
		if(!loaderClass.isLoaderOpen) loaderClass.open();
		if(!loaderClass.isLoaderOpen && loaderClass.icon) loaderClass.switch();
		//await this.populate()
		gsap.to(this.tickets, { duration: 0, autoAlpha: 1 })
		gsap.to(this.tickets.querySelector('.tickets--container'), { duration: 1, x: 0, ease: 'power4.inOut', onComplete: () => {
			this.isAnimating = false;
			this.isOpen = true;
		}})
	}
	async close() {
		if(!this.isOpen || this.isAnimating) return;
		this.isAnimating = true;
		gsap.to(this.tickets.querySelector('.tickets--container'), { duration: 1, x: '100%', ease: 'power4.inOut', onComplete: () => {
			this.isAnimating = false;
			this.isOpen = false;
			scrollInstance.start()
			loaderClass.close();
			
			gsap.to(this.tickets, { duration: 0, autoAlpha: 0 })
			
		}})
	}
}

export { Tickets };